import React from 'react';
import { Button, Modal } from 'antd';
import ModalAddExpense from './ModalAddExpense';
import { deleteData } from '../../helper/api';
import { toast } from 'react-toastify';

function ActionExpense(props) {
    const { record, trigerFetchData, setTrigerFetchData } = props;
    const [openModalAdd, setOpenModalAdd] = React.useState(false);
    const [openModalDelete, setOpenModalDelete] = React.useState(false);

    const handleDeleteExpense = () => {
        deleteData(`/expenses/${record.id}`)
            .then((response) => {
                if (response.status === 200) {
                    toast.success('Expense deleted successfully');
                    setTrigerFetchData(!trigerFetchData);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div style={{ display: "flex", gap: "20px" }}>
             <Modal
                title="Delete"
                open={openModalDelete}
                onOk={() => handleDeleteExpense()}
                onCancel={() => setOpenModalDelete(false)}
            >
                {/* ARE YOU SURE */}
                <h2>Are you sure want to delete this expense {record.id}?</h2>
            </Modal>
            <ModalAddExpense open={openModalAdd} setOpen={setOpenModalAdd} initialData={record} trigerFetchData={trigerFetchData} setTrigerFetchData={setTrigerFetchData} />
            <Button className="items-center flex justify-center text-white bg-blue-400" onClick={() => setOpenModalAdd(true)}>
                Edit
            </Button>
            <Button className="items-center flex justify-center text-white bg-blue-400" danger onClick={() => setOpenModalDelete(true)}>
                Delete
            </Button>
        </div>
    );
}

export default ActionExpense;